import Footer from "../Footer/Footer";
import Header from "../Header/Header";

import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockSubtitle from "../Block/BlockSubtitle";
import BlockText from "../Block/BlockText";
import BlockImage from "../Block/BlockImage";
import BlockButton from "../Block/BlockButton";
import Block from "../Block/Block";
import { useNavigate } from 'react-router-dom';

function Blog() {
  const navigate = useNavigate();
  return (
    <div>
      <Header/>      

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%" textAlign="center" color="grey" fontStyle="italic">
          <BlockTitle fontSize="25px" fontWeight="normal">An enigmatic assortment of odds and ends.</BlockTitle>
        </BlockContent>
      </Block>

      {/* <Block colorTheme="dark" gridTemplateColumns="600px 600px">
        <BlockContent width="20%">
          <BlockImage src={process.env.PUBLIC_URL + '/card_philippinepassport.webp'}/>
        </BlockContent>
        <BlockContent width="60%">
          <BlockSubtitle>Philippine Passport application for German citizens with Philippine heritage.</BlockSubtitle>
          <BlockText>As a German citizen born in Germany to Filipino parents, you are also recognized as a Filipino citizen by birth, affording you specific rights, such as eligibility for a Philippine passport. This article provides a detailed step-by-step guide on how to apply for a Philippine passport.</BlockText>
          <BlockButton onClick={() => navigate('/Blog/Passport')}>Learn more</BlockButton>
        </BlockContent>
      </Block>     */}

  {/* <Block colorTheme="light" gridTemplateColumns="600px 600px">
    <BlockContent width="60%">
      <BlockSubtitle>List of Conferences, Journals and Workshops in the field of Computer Vision, Computer Graphics and AI</BlockSubtitle>
      <BlockText>This blog entry provides details about upcoming and recently concluded events, including important dates such as paper submission deadlines and event dates. The focus is on topics in the fields of Computer Vision, Computer Graphics, and AI.</BlockText>
      <BlockButton onClick={() => navigate('/Blog/Publications')}>Learn more</BlockButton>
    </BlockContent>
    <BlockContent width="20%">
      <BlockImage src={process.env.PUBLIC_URL + '/card_publications.webp'}/>
    </BlockContent>
  </Block>    */}

      <Footer/>
    </div>
  );
}

export default Blog;
